import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { getUserSelector } from '@store/auth';
import { getGlobalVariableSelector } from '@store/global-variables';
import { Routes } from '@enums';
import { DrawerComponent } from '@components/header/components';
import { Icon, IconButton, Typography } from '@elements';
import { colors } from '@themes';
import { MenuButton, StyledAppBar, StyledContainer, StyledIcon, StyledIconButton, StyledToolbar } from './header.styles';
import burger from '@assets/images/burger.svg';
import cart from '@assets/images/cart.svg';
import logo from '@assets/images/logo-big.svg';
import person from '@assets/images/person.fill.svg';
import { menuItems, onAuthClick } from './header.helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Header = function Header() {
  var theme = useTheme();
  var isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setIsOpen = _useState2[1];

  var navigate = useNavigate();
  var user = useSelector(getUserSelector);
  var basket = useSelector(getGlobalVariableSelector('basket'));
  var basketLength = Array.isArray(basket) ? basket.length : 0;

  var isRouteActive = function isRouteActive(route) {
    var _location = location,
        pathname = _location.pathname;
    return pathname.indexOf(route) >= 0;
  };

  var goToRoute = function goToRoute(route, isExternal) {
    return function () {
      if (isExternal) {
        window.open(route, '_blank');
        setIsOpen(false);
      } else {
        navigate(route);
        setIsOpen(false);
      }
    };
  };

  var toggleDrawer = function toggleDrawer(event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setIsOpen(!open);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledAppBar, {
      color: "transparent",
      elevation: 0,
      children: /*#__PURE__*/_jsx(StyledToolbar, {
        disableGutters: true,
        children: /*#__PURE__*/_jsxs(StyledContainer, {
          fixed: true,
          children: [isSmallScreen && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(IconButton, {
              onClick: toggleDrawer,
              children: /*#__PURE__*/_jsx(Icon, {
                src: burger,
                width: 28,
                height: 28
              })
            }), /*#__PURE__*/_jsx(DrawerComponent, {
              open: open,
              toggleDrawer: toggleDrawer,
              goToRoute: goToRoute,
              isRouteActive: isRouteActive
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: 1,
            children: [/*#__PURE__*/_jsx(IconButton, {
              onClick: function onClick() {
                return location.replace('https://hcamur.ru');
              },
              sx: {
                padding: 0
              },
              children: /*#__PURE__*/_jsx(Icon, {
                src: logo,
                width: 44,
                height: 44
              })
            }), isSmallScreen ? null : menuItems.filter(function (item) {
              return item.route !== Routes.Basket;
            }).map(function (menuItem) {
              return /*#__PURE__*/_jsxs(MenuButton, {
                onClick: goToRoute(menuItem.route, menuItem === null || menuItem === void 0 ? void 0 : menuItem.isExternal),
                variant: "text",
                active: isRouteActive(menuItem.route),
                $color: isRouteActive(menuItem.route) ? 'internationalOrange' : 'secondarySilver',
                children: [menuItem.icon && /*#__PURE__*/_jsx(StyledIcon, {
                  src: menuItem.icon,
                  width: 24,
                  height: 24,
                  customColor: isRouteActive(menuItem.route) ? colors.internationalOrange : colors.secondarySilver
                }), /*#__PURE__*/_jsx(Typography, {
                  fontSize: "22px",
                  lineHeight: "normal",
                  letterSpacing: "0.35px",
                  fontWeight: 400,
                  children: menuItem.label
                })]
              }, menuItem.route);
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            children: [(!isSmallScreen || isSmallScreen && !user) && /*#__PURE__*/_jsx(StyledIconButton, {
              onClick: onAuthClick(user),
              children: /*#__PURE__*/_jsx(Icon, {
                src: person,
                width: 28,
                height: 28
              })
            }), !!user && /*#__PURE__*/_jsxs(StyledIconButton, {
              onClick: function onClick() {
                navigate(Routes.Basket);
              },
              filled: basketLength > 0,
              sx: {
                '& i': {
                  '& svg': {
                    '& g': {
                      '& path': {
                        fill: basketLength > 0 ? colors.internationalOrange : 'rgb(158, 158, 158)'
                      }
                    }
                  }
                }
              },
              children: [basketLength > 0 && /*#__PURE__*/_jsx(Box, {
                width: "9px",
                height: "9px",
                position: "absolute",
                top: "10px",
                right: "10px",
                sx: {
                  borderRadius: '50%',
                  backgroundColor: basketLength > 0 ? colors.internationalOrange : 'rgb(158, 158, 158)'
                }
              }), /*#__PURE__*/_jsx(Icon, {
                src: cart,
                width: 28,
                height: 28
              })]
            })]
          })]
        })
      })
    })
  });
};

export { Header };